import React, {useEffect, useState} from "react";
import SideBar from "../../Navbars/SideBar";
import NavBar from "../../Navbars/NavBar";
import {
    Dialog,
    Button,
    SearchInput,
} from "evergreen-ui";
import {
    MDBAlert,
    MDBCol, MDBIcon,
    MDBRow,
} from "mdbreact";
import {Card, Layout, Modal, Table, Tooltip} from "antd";
import {Text} from "react-font";
import { useList, useListVals } from 'react-firebase-hooks/database';
import Firebase from "../../../Firebase";
import {useAuthState} from "react-firebase-hooks/auth";
import CreateProductModal from "../../Modals/Product/CreateProductModal";
import { useHistory } from 'react-router-dom';


const { Content } = Layout;
const outletsRef = Firebase.database().ref('System/Outlets');
const prodRef = Firebase.database().ref('System/Products');
var prodStoreRef = Firebase.storage().ref("System/Products");
const moment = require("moment");
const Products = () => {

    const columns = [
        {
            title: 'Key',
            dataIndex: 'key',
            key: 'key',
        },
        {
            title: 'Outlet Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
        },
        {
            title: 'No. of Products',
            dataIndex: 'products',
            key: 'products',
        },{
            title: 'View Products',
            dataIndex: 'action',
            key: 'action',
        },
    ];


    const [checkedData, setCheckedData] = useState(true);
    const callback = (data) => {
        setCheckedData(data);
    }
    const history = useHistory();
    const [outlets, loading, error] = useListVals(outletsRef);
    const [products, prodsLoading, prodsError] = useListVals(prodRef);
    const [loggedInUser] = useAuthState(Firebase.auth());
    const [showDeleteAlert, setDeleteAlert] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [dataArray, setDataArray] = useState([]);
    const [outletArray, setOutletArray] = useState([]);
    const [color, setColor] = useState("info");
    const [message, setMessage] = useState("");
    const [viewModal, setViewModal] = useState(false);
    const [productArray, setProductArray] = useState([]);
    const [selectedOutlet, setSelectedOutlet] = useState(null);


    useEffect(() => {
        if(loggedInUser){
            //console.log("logged in")
            if(error){
                alert(error.message);
            }

            if(products){
                var prodArray = [];
                products.map((product) => {
                    var urlArray = []
                    prodStoreRef.child(product.productID).listAll()
                        .then((res) => {
                            res.items.forEach((itemRef) => {
                                // All the items under listRef.
                                itemRef.getDownloadURL().then((url) => {
                                    urlArray.push(url);
                                })
                            });
                        }).catch((error) => {
                        // Uh-oh, an error occurred!
                    });

                    product.urls = urlArray;
                    prodArray.push(product);

                })
                setProductArray([...prodArray]);
            }

            if(outlets){
                var tempArray = [];
                outlets.map((outlet, index) => {

                    var countArray = products.filter(x =>  x.outletID === outlet.outletID);

                    tempArray.push({
                        key: index + 1,
                        name: outlet.name,
                        location : outlet.location,
                        products : countArray.length,
                        action: <div>
                            <Tooltip placement="top" title="view it's products">

                                <Button intent="primary" onClick={() => {
                                    gotoProducts(outlet);
                                }}>
                                    <MDBIcon icon="angle-double-right" size="2x" />
                                </Button>
                            </Tooltip>
                        </div>
                    });
                });

                setDataArray([...tempArray]);
                setOutletArray([...tempArray]);
            }
        } else {
            //window.location.href = "/login";
        }

    }, [error, loggedInUser, outlets, products]);


    const handleSearch = searchText => {
        const filteredEvents = outletArray.filter(({ name, location }) => {
            name = name.toLowerCase();
            location = location.toLowerCase();
            return name.includes(searchText) || location.includes(searchText);
        });

        setDataArray(filteredEvents);
    };

    const gotoProducts = (outlet) => {

        history.push({
            pathname: '/products',
            outlet: outlet,
        });

    }


    return (

        <>

            <Layout style={{width: "100vw"}}>
                <SideBar checked={checkedData}/>
                <Layout className="site-layout">
                    <NavBar token={"token"} checkBack={callback}/>
                    <Content
                        className="site-layout-background"
                        style={{ margin: '10px 16px 15px'}}
                    >
                        <MDBRow className="w-100">
                            <MDBCol md={12}>

                                <Dialog
                                    isShown={showModal}
                                    title="Create New Product"
                                    onCloseComplete={() => {setShowModal(false)}}
                                    shouldCloseOnOverlayClick={false}
                                    hasFooter={false}>

                                    <MDBCol md={12}>
                                        <CreateProductModal modal={setShowModal}/>
                                    </MDBCol>

                                </Dialog>

                                <Card className="w-100">

                                    <MDBRow>
                                        <MDBCol md={12} className="w-100">
                                            <div className="text-left">
                                                <div className="d-block">
                                                    <h5 className="font-weight-bold">
                                                        <Text family='Nunito'>
                                                            Products
                                                        </Text>
                                                    </h5>
                                                </div>
                                            </div>

                                            <MDBRow className="ml-1">
                                                <SearchInput height={40} placeholder="Search outlets" className="w-100"   onChange={e => handleSearch(e.target.value)} />
                                                <Button height={40} appearance="primary" className="mx-2" onClick={() => {setShowModal(true)}}>
                                                    New Product
                                                </Button>
                                            </MDBRow>
                                        </MDBCol>

                                    </MDBRow>

                                </Card>

                                <Card>
                                    {showDeleteAlert?
                                        <>
                                            <MDBAlert color={color} className="my-3 font-italic" >
                                                {message}
                                            </MDBAlert>
                                        </>
                                        : null }
                                    <Card className="d-flex flex-column">
                                        <div>
                                            <Table style={{overflow: "auto"}} id={"dataTable"} loading={loading} dataSource={dataArray} columns={columns} />
                                        </div>
                                    </Card>
                                </Card>

                            </MDBCol>
                        </MDBRow>
                    </Content>
                </Layout>
            </Layout>

        </>
    )

}

export default Products;